import React, { useState } from "react";
import theme from "../../styles/theme.json";
import util from "../../util";
import moment from "moment";
import "moment/locale/pt-br";

const DateTime = ({
  datas,
  dataSelecionada,
  setDataSelecionada,
  horaSelecionada,
  setHoraSelecionada,
}) => {
  // Mapeia datas para um objeto mais fácil de acessar
  const diasComHorarios = datas.reduce((acc, item) => {
    const date = Object.keys(item)[0];
    const horarios = Object.values(item)[0];
    acc[date] = horarios;
    return acc;
  }, {});

  const handleDateSelection = (dateISO) => {
    setDataSelecionada(dateISO);
    setHoraSelecionada("");
  };

  const handleTimeSelection = (horario) => {
    setHoraSelecionada(horario);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "0px" }}>
      {/* Seleção de Data */}
      <div>
        <h4
          style={{
            fontWeight: "700",
            marginBottom: "10px",
            color: theme.colors.dark,
          }}
        >
          Para qual dia?
        </h4>
        <div
          style={{
            display: "flex",
            overflowX: "auto",
            gap: "10px",
            padding: "10px 0",
            scrollbarWidth: "none",
          }}
        >
          {Object.entries(diasComHorarios).map(([date], index) => {
            const dateMoment = moment(date);
            const dateISO = dateMoment.format("YYYY-MM-DD");
            const selected = dateISO === dataSelecionada;

            return (
              <div
              key={index}
              onClick={() => handleDateSelection(dateISO)}
              style={{
                border: `1px solid ${
                  selected
                    ? theme.colors.primary
                    : util.toAlpha(theme.colors.muted, 20)
                }`,
                width: "70px",
                height: "90px",
                background: selected ? theme.colors.primary : theme.colors.light,
                borderRadius: "15px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center", // centraliza verticalmente
                alignItems: "center",
                cursor: "pointer",
                minWidth: "80px",
                padding: "5px",
              }}
            >
              <span
                style={{
                  fontSize: "12px",
                  color: selected ? theme.colors.light : theme.colors.dark,
                  marginBottom: "2px", // diminui o espaço
                }}
              >
                {util.diasSemana[dateMoment.day()]}
              </span>
              <h4
                style={{
                  fontSize: "16px",
                  color: selected ? theme.colors.light : theme.colors.dark,
                  margin: "0 0 2px 0", // diminui o espaço
                }}
              >
                {dateMoment.format("DD")}
              </h4>
              <span
                style={{
                  fontSize: "12px",
                  color: selected ? theme.colors.light : theme.colors.dark,
                  marginTop: "0", // remove espaço extra
                }}
              >
                {dateMoment.format("MMMM")}
              </span>
            </div>
            );
          })}
        </div>
      </div>

      {/* Seleção de Horário */}
      <div>
        <h4
          style={{
            fontWeight: "700",
            marginBottom: "10px",
            color: theme.colors.dark,
          }}
        >
          Escolha um horário
        </h4>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "10px",
            padding: "10px 0",
            overflowX: "auto",
          }}
        >
          {dataSelecionada ? (
            diasComHorarios[dataSelecionada] &&
            Object.keys(diasComHorarios[dataSelecionada]).length > 0 ? (
              (() => {
                // 🔹 Junta todos os horários de todos os colaboradores
                let todosHorarios = [];
                Object.values(diasComHorarios[dataSelecionada]).forEach((slots) => {
                  todosHorarios = [...todosHorarios, ...slots.map((s) => s[0])];
                });

                // 🔹 Remove duplicados e ordena
                const horariosUnicos = [...new Set(todosHorarios)].sort((a, b) =>
                  moment(a, "HH:mm").diff(moment(b, "HH:mm"))
                );

                return horariosUnicos.map((horario) => {
                  const selected = horario === horaSelecionada;
                  return (
                    <div
                      key={horario}
                      onClick={() => handleTimeSelection(horario)}
                      style={{
                        height: "35px",
                        background: selected
                          ? theme.colors.primary
                          : theme.colors.light,
                        borderRadius: "7px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        border: `1px solid ${
                          selected
                            ? theme.colors.primary
                            : util.toAlpha(theme.colors.muted, 20)
                        }`,
                      }}
                    >
                      <span
                        style={{
                          color: selected ? theme.colors.light : theme.colors.dark,
                        }}
                      >
                        {horario}
                      </span>
                    </div>
                  );
                });
              })()
            ) : (
              <p>Sem horários disponíveis</p>
            )
          ) : (
            <p>Selecione um dia para ver os horários</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DateTime;
